
import React from 'react';
import { Student } from '@/types/models';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { formatDate } from '@/lib/format';
import { Link2 } from 'lucide-react';

interface StudentInformationCardProps {
  student: Student;
  onViewFamily: () => void;
  studentFamily: { id: string; name: string } | null;
  onConnectToFamily?: () => void;
}

const StudentInformationCard: React.FC<StudentInformationCardProps> = ({
  student,
  onViewFamily,
  studentFamily,
  onConnectToFamily,
}) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Student Information</CardTitle>
      </CardHeader>
      <CardContent className="grid gap-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <Label>First Name</Label>
            <Input type="text" value={student.first_name} readOnly />
          </div>
          <div>
            <Label>Last Name</Label>
            <Input type="text" value={student.last_name} readOnly />
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <Label>Date of Birth</Label>
            <Input type="text" value={student.date_of_birth ? formatDate(student.date_of_birth) : 'N/A'} readOnly />
          </div>
          <div>
            <Label>Gender</Label>
            <Input type="text" value={student.gender || 'N/A'} readOnly />
          </div>
        </div>
        <div>
          <Label>Notes</Label>
          <Input type="text" value={student.notes || 'N/A'} readOnly />
        </div>
        
        {studentFamily ? (
          <div>
            <Button variant="outline" size="sm" onClick={onViewFamily}>
              View Family Information
            </Button>
          </div>
        ) : (
          <div>
            <Button 
              variant="outline" 
              size="sm" 
              onClick={onConnectToFamily}
              className="flex items-center gap-2"
            >
              <Link2 className="h-4 w-4" />
              Connect to Family
            </Button>
            <p className="text-sm text-muted-foreground mt-2">
              This student is not connected to any family.
            </p>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default StudentInformationCard;
